import styled from 'styled-components';

const SearchingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export default SearchingContainer;
